import React from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";

export function NextArrow(props) {
    const { className, style, onClick } = props;

    return (
      <div
        className={className}
        style={{ 
          ...style, 
          display: "flex",
          justifyContent: 'center',
          alignItems: 'center',
          background: '#FFFFFF',
          width: 46,
          height: 46,
          borderRadius: '50%'
        }}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faChevronRight} />
      </div>
    );
  }
  
export function PrevArrow(props) {
    const { className, style, onClick } = props;

    return (
      <div
        className={className}
        style={{ 
          ...style, 
          display: "flex",
          justifyContent: 'center',
          alignItems: 'center',
          background: '#FFFFFF',
          width: 46,
          height: 46,
          borderRadius: '50%'
        }}
        onClick={onClick}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </div>
    );
  }